'use strict';

module.exports = {
    templates: 0,
    categories: 1,
    promotions: 2,
};
